module.exports = __webpack_public_path__ + "img/qyxw.97449308.png";